export default __webpack_public_path__ + "static/media/CFiti.49d041bb.jpg";